const focus = {}

function setFocus(el){
    el.focus()
    //var cont = document.querySelector("#main-container")
    //cont.scrollTop = cont.scrollHeight
}

focus.install = function(Vue){
    Vue.directive('focus', {        
        inserted(el, binding){
            setFocus(el, binding)
        }
    })
}

export default focus